import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=b5ac57be&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports